import script from "./AutomatedNotif.vue?vue&type=script&setup=true&lang=js"
export * from "./AutomatedNotif.vue?vue&type=script&setup=true&lang=js"

import "./AutomatedNotif.vue?vue&type=style&index=0&id=55c8ee30&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55c8ee30"]])

export default __exports__